import Common from '../../Common';

interface postBody {
	department_id: id
}

const Department = class extends Common {
	create = (contactId: id, body: postBody) =>
		this.post(`/contact/${contactId}/department`, body)

	delete = (contactId: id, departmentId: id) =>
		this.doDelete(`/contact/${contactId}/department/${departmentId}`)
}

export default Department
